var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.707 12.293C9.61475 12.1975 9.50441 12.1213 9.3824 12.0689C9.2604 12.0165 9.12918 11.9889 8.9964 11.9877C8.86362 11.9866 8.73194 12.0119 8.60905 12.0622C8.48615 12.1125 8.3745 12.1867 8.2806 12.2806C8.18671 12.3745 8.11246 12.4861 8.06218 12.609C8.0119 12.7319 7.9866 12.8636 7.98775 12.9964C7.9889 13.1292 8.01649 13.2604 8.0689 13.3824C8.12131 13.5044 8.19749 13.6148 8.293 13.707L11.293 16.707C11.4805 16.8945 11.7348 16.9998 12 16.9998C12.2652 16.9998 12.5195 16.8945 12.707 16.707L15.707 13.707C15.8892 13.5184 15.99 13.2658 15.9877 13.0036C15.9854 12.7414 15.8802 12.4906 15.6948 12.3052C15.5094 12.1198 15.2586 12.0146 14.9964 12.0123C14.7342 12.01 14.4816 12.1108 14.293 12.293L13 13.586V8H18C18.5304 8 19.0391 8.21071 19.4142 8.58579C19.7893 8.96086 20 9.46957 20 10V17C20 17.5304 19.7893 18.0391 19.4142 18.4142C19.0391 18.7893 18.5304 19 18 19H6C5.46957 19 4.96086 18.7893 4.58579 18.4142C4.21071 18.0391 4 17.5304 4 17V10C4 9.46957 4.21071 8.96086 4.58579 8.58579C4.96086 8.21071 5.46957 8 6 8H11V13.586L9.707 12.293ZM11 6C11 5.73478 11.1054 5.48043 11.2929 5.29289C11.4804 5.10536 11.7348 5 12 5C12.2652 5 12.5196 5.10536 12.7071 5.29289C12.8946 5.48043 13 5.73478 13 6V8H11V6Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8273d83063a5e643d7f468fc0e29bde8.svg";
export { ForwardRef as ReactComponent };